import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.neutral.main,

  "&:hover, &:focus, &:hover *, &:focus *": {
    color: theme.palette.primary.main,
    textDecoration: "none",
  },
}));
